import { atom } from "jotai";

import { currentBookingAtom } from "../../stores";

export const isAlreadyPaidAtom = atom((get) => {
  const booking = get(currentBookingAtom);
  return !!booking?.isAlreadyPaid;
});
